import React from "react"
import OurStoryPage from "../pages_/our-story/index.page"

export default () => (

  <OurStoryPage />

)